import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'RulerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ruler",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 8l2 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 12l3 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 16l2 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 4l0 2"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 4l0 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 4l0 2"
    }, null), _createTextVNode(" ")]);
  }
};